import { Flex, xcss } from '@atlaskit/primitives';

import { RightHandSideProps } from '../../../common/types';
import { useGetSelectedCodingAgentAvatarsFromSearchParams } from '../../../controllers';
import { BoardColumnsSvg } from '../../assets/board-columns-svg';
import { Injections, ProjectSvg } from '../../assets/project-svg';

import { CollaborationIcons } from './collaboration-icons';
export const RightHandSidePageInvite = ({
	projectName,
	columnNames,
}: RightHandSideProps & { columnNames: string[] }) => {
	const assignedAgents = useGetSelectedCodingAgentAvatarsFromSearchParams();
	const injections: Injections = {
		additionalObject: CollaborationIcons,
		svgBody: BoardColumnsSvg({ columnNames, assignedAgents }),
	};
	return (
		<Flex alignItems="center" justifyContent="center" xcss={containerStyles}>
			<ProjectSvg projectName={projectName} activeView="board" injections={injections} />
		</Flex>
	);
};
const containerStyles = xcss({
	height: '100%',
	backgroundColor: 'elevation.surface',
});
